"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBuffer = void 0;
exports.isBuffer = (value) => Buffer.isBuffer(value);
//# sourceMappingURL=is-buffer.js.map